"use client";

import { useEffect, useRef, useState } from "react";

export function useNearViewport(rootMargin = "600px") {
  const targetRef = useRef<HTMLDivElement>(null);
  const [isNearViewport, setIsNearViewport] = useState(false);

  useEffect(() => {
    if (isNearViewport) return;

    const target = targetRef.current;
    if (!target) return;

    if (!("IntersectionObserver" in window)) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- Browsers without the observer must load content once the client capability is known.
      setIsNearViewport(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry?.isIntersecting) return;
        setIsNearViewport(true);
        observer.disconnect();
      },
      { rootMargin },
    );

    observer.observe(target);
    return () => observer.disconnect();
  }, [isNearViewport, rootMargin]);

  return { targetRef, isNearViewport };
}
